import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './BannerSlider.css';

const BannerSlider = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getImage = (desktop, mobile) => (isMobile ? mobile : desktop);

  const banners = [
    { alt: "Bank Of India", file: "Bank Of India.png" },
    { alt: "Bank Of Baroda", file: "Bank Of Baroda.png" },
    { alt: "ICICI Bank", file: "ICICI bank.png" },
    { alt: "Bank Of Maharashtra", file: "Bank Of Maharashtra.png" },
    { alt: "Central Bank Of India", file: "central bank of india.png" },
    { alt: "SBI Bank", file: "SBI Bank.png" },
    { alt: "IDBI Bank", file: "IDBI Bank.png" },
    { alt: "HDFC Bank", file: "HDFC Bank.png" },
    { alt: "Indian Overseas Bank", file: "Indian overseas Bank.png" },
  ];

  return (
    <div className="elementor-banner-slider border border-primary">
      <div id="elementorBannerSlider" className="carousel slide carousel-fade" data-bs-ride="carousel">
        <div className="carousel-inner">
          {banners.map((banner, idx) => (
            <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
              <a href="/apply-now">
                <img
                  src={getImage(
                    `/images/Banner/${banner.file}`,
                    `/images/Banner-Mobile/${banner.file}`
                  )}
                  className="d-block w-100 banner-slide-img"
                  alt={banner.alt}
                />
              </a>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#elementorBannerSlider" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#elementorBannerSlider" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default BannerSlider;
